export const ACCESS_TOKEN = "ACCESS_TOKEN";
export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const USER_DATA = "USER_DATA";
export const PERMISSIONS = "PERMISSIONS";
export const LOGGED_IN = "LOGGED_IN";
export const REMEMBER_ME = "REMEMBER_ME";
export const TOKEN_EXPIRED = "TOKEN_EXPIRED";
export const REFRESH_TOKEN_EXPIRED = "REFRESH_TOKEN_EXPIRED";
export const TOKEN_TYPE = "TOKEN_TYPE";
export const SUCCESS_CODE = "0000";
export const ERR_0013 = "ERR-0013";
export const ERR_0017 = "ERR-0017";
export const ERR_0022 = "ERR-0022";
export const ERR_0051 = "ERR-0051";
export const DATA_MASTER_DATA_TYPE = "data";
export const COMPANY_TYPE = "company_type";
export const REGION_GROUP = "region_group";
export const INDUSTRY_TYPE = "industry_type";
export const CURRENT_CUSTOMER_INDUSTRY_TYPE = "current_customer_industry_type";
export const INSTITUTION = "institution";
export const WORK_PERIOD = "work_period";
export const EXPECTED = "expected";
export const TOUCH_POINT_CHANNEL_DIGITAL = "touch_point_channel_digital";
export const TOUCH_POINT_CHANNEL_PHYSICAL = "touch_point_channel_physical";
export const AREA_TYPE = "area_type";
export const VOC_MASTER_DATA_TYPE = "voc";
export const BUSINESS_REQUIRE = "business_require";
export const CUSTOMER_EXPECT = "customer_expect";
export const CUSTOMER_SUPPORT = "customer_support";
export const OTHER_BUSINESS_EXPECT = "other_business_expect";
export const OTHER_PRODUCT_EXPECT = "other_product_expect";
export const OTHER_SUPPORT_EXPECT = "other_support_expect";
export const PRODUCT_REQUIREMENT = "product_requirement";
export const PERMISSION = "permission";
export const INDUSTRY = "industry";
export const PROVICE = "province";
export const ESTATE_TYPE = "estate_type";
export const PERMISSION_DATA = {
  APPLICATION: "Application field",
  DASHBOARD: "Dashboard",
  SEARCH: "Search/Edit",
  IMPORT_DATA: "Import Raw Data",
};
export const PAGES = {
  CURRENT_CUSTOMER: "ข้อมูลลูกค้าปัจจุบัน",
  FUTURE_CUSTOMER: "ข้อมูลลูกค้าอนาคต",
  STAKEHOLDER: "ข้อมูลผู้มีส่วนได้ส่วนเสีย",
  TOUCHPOINT: "ข้อมูล Touch Point",
  COMPETITOR: "ข้อมูลคู่แข่ง",
  AREAUSAGE: "ข้อมูลการใช้พื้นที่",
  VISIT: "ข้อมูลการเยี่ยมชม",
  VOC_CURRENT: "รายงานจัดอันดับลูกค้าปัจจุบัน",
  VOC_FUTURE: "รายงานจัดอันดับลูกค้าอนาคต",
};

export const EFFECTIVENESS = [
  {
    value: "เป็นไปตามแผน",
  },
  {
    value: "เร็วกว่าแผน",
  },
  {
    value: "ช้ากว่าแผน",
  },
];

export const MONTH = {
  1: "ม.ค.",
  2: "ก.พ.",
  3: "มี.ค.",
  4: "เม.ย.",
  5: "พ.ค.",
  6: "มิ.ย.",
  7: "ก.ค.",
  8: "ส.ค.",
  9: "ก.ย.",
  10: "ต.ค.",
  11: "พ.ย.",
  12: "ธ.ค.",
};

export const PREFIX = [
  {
    value: "นาย",
  },
  {
    value: "นาง",
  },
  {
    value: "นางสาว",
  },
];
